<template>
    <div class="g pop-up-inner">
        <mdToggleAside
            @sendEvent="close"
        ></mdToggleAside>
        <mdCaption
            :caption="content.caption || $t('talk.Upload')"
            :minorCaption="content.minorCaption"
        ></mdCaption>
        <div class="g pop-up-content">
            <div class="g pop-up-content-inner">
                <div class="g">
                    <div class="md" v-if="content.html" v-html="content.html"></div>
                    <mdUploader
                        ref="uploader"

                        :files="files"
                        :accept="content.accept"
                        :multiple="content.multiple"

                        @sendEvent="receiveEvent"
                    ></mdUploader>
                </div>
            </div>
        </div>
        <mdBtnList
            :content="btns"
            :block="true"
            @sendEvent="receiveEvent"
        ></mdBtnList>
    </div>
</template>

<script>
    import mdCaption from '@/components/mdCaption'
    import mdToggleAside from '@/components/mdToggleAside'
    import mdUploader from '@/components/mdUploader'
    import mdBtnList from '@/components/mdBtnList'

    export default {
        components: {
            mdCaption,
            mdToggleAside,
            mdUploader,
            mdBtnList,
        },
        props: {
            sn: {
                require: true
            },
            content: {
                type: Object,
                require: true
            }
        },
        data: function(){

            return {
                files: [],
            }
        },
        computed: {
            btns: function(){
                let $content = this.content || {},
                    $moreBtns = $content.moreBtns || []

                let $action = {
                        text: $content.actionName || this.$t('site.status.confirm'),
                        icon: $content.actionIcon || '',
                        themes: $content.actionTheme? $content.actionTheme: 'major',
                        func: 'action',
                    },
                    $cancel = {
                        text: $content.cancelName || this.$t('site.func.popupclose'),
                        icon: $content.cancelIcon || '',
                        themes: $content.cancelTheme || '',
                        func: 'close',
                    }

                let $results = [].concat($moreBtns);

                $results.push($action);
                $results.push($cancel);

                return $results;
            },
        },
        methods: {
            sendFuncEvent: function(func){ //多 btn 功能
                let $content = this.content,
                    $files = this.files;

                $content[func]($files);
            },
            uploadFile: function(files){
                let $content = this.content,
                    _multiple = $content.multiple || false,
                    _accept = $content.accept || '',
                    $accept = _accept.split(',');

                let $files = this.files,
                    _length = files.length;

                let $_makeItem = (item) => {
                        let _name = item.name,
                            _ext = '.'+ this.$okaTool.getExtension(_name),
                            _theme = 'info',
                            _text = this.$t('site.status.canupload');

                        if( _accept && !$accept.includes(_ext) ) {
                            _theme = 'danger';
                            _text = this.$t('site.status.typeError');
                        }

                        return {
                            caption: _name,
                            size: item.size,
                            process: 0,
                            text: _text,
                            theme: _theme,
                            action: false,
                            data: item,
                        }
                    }

                if( _length ) {

                    if( _multiple ) {

                        for( let _i = 0; _i < _length; _i++ ) {
                            let $file = files[_i],
                                $item = $_makeItem($file);

                            $files.push($item);
                        }
                    }else {
                        let $file = files[0],
                            $item = $_makeItem($file);

                        this.$set(this, 'files', [$item]);
                    }
                }
            },
            clickItem: function(file){
                console.log('clickItem', file);
            },
            removeItem: function(file){
                let $files = this.files,
                    _index = $files.indexOf(file);

                $files.splice(_index, 1);
            },
            action: function(){
                // this.$refs.uploader.$validator.validate().then(result => {
                //     if (!result){
                //         //啊就沒通過啊
                //     }else {
                //         let $content = this.content,
                //             $_action = $content.action,
                //             $files = this.files,
                //             $result = {}

                //         $files.forEach((file, index) => {

                //             if( file.status !== 'danger' ) {
                //                 $result[index] = file.data;
                //             }
                //         });

                //         $result.length = $files.length;

                //         $_action($result);

                //         if( $content.actionStopClose !== true ) {
                //             this.close();
                //         }
                //     }
                // });

                let $content = this.content,
                    $_action = $content.action,
                    $files = this.files,
                    $result = {}

                $files.forEach((file, index) => {

                    if( file.status !== 'danger' ) {
                        $result[index] = file.data;
                    }
                });

                $result.length = $files.length;

                $_action($result);

                if( $content.actionStopClose !== true ) {
                    this.close();
                }
            },
            close: function(){
                this.$emit('sendEvent', 'clearPopUp', this.sn);
            },
        }
    }
</script>

<style scoped lang="scss">

    .g.pop-up-inner {
        width: 800px;
    }
</style>
